export const imagesProfileData = require(`../assets/images/profile/profile_2.jpg`);
export const imagesGalleryData = [
  {
    id: 1,
    src: require(`../assets/images/gallery/gallery_1.jpg`),
    alt: "Image 1",
    description: "Busway",
  },
  {
    id: 2,
    src: require(`../assets/images/gallery/gallery_3.jpg`),
    alt: "Image 2",
    description: "Nerd",
  },
  {
    id: 3,
    src: require(`../assets/images/gallery/gallery_2.jpg`),
    alt: "Image 3",
    description: "Commuter Line",
  },
  {
    id: 4,
    src: require(`../assets/images/gallery/gallery_4.jpg`),
    alt: "Image 4",
    description: "Traffic",
  },
  {
    id: 5,
    src: require(`../assets/images/gallery/gallery_5.jpg`),
    alt: "Image 5",
    description: "No Stand",
  },
  {
    id: 6,
    src: require(`../assets/images/gallery/gallery_6.jpg`),
    alt: "Image 6",
    description: "Cloud City",
  },
];
export const portofolioData = [
  {
    id: 1,
    label: "Aksestoko CRM",
    value: "01",
    alt: "akses toko CRM",
    src: require(`../assets/images/portofolio/portofolio_1.png`),
  },
  {
    id: 2,
    label: "Shayna Landing",
    value: "02",
    alt: "shayna",
    src: require(`../assets/images/portofolio/portofolio_2.png`),
  },
  {
    id: 3,
    label: "Startup Landing",
    value: "03",
    alt: "startup",
    src: require(`../assets/images/portofolio/portofolio_3.png`),
  },
  {
    id: 4,
    label: "Gocement",
    value: "04",
    alt: "gocement",
    src: require(`../assets/images/portofolio/portofolio_4.png`),
  },
  {
    id: 5,
    label: null,
    value: null,
    src: "",
  },
  {
    id: 6,
    label: "Onklas Sekolah",
    value: "05",
    alt: "onklas sekolah",
    src: require(`../assets/images/portofolio/portofolio_5.png`),
  },
];
